import { Trans } from '@lingui/react/macro';

import Box from '@/design_system/Box';
import FoldableSection from '@/design_system/FoldableSection';
import Stack from '@/design_system/Stack';
import Title from '@/design_system/Typography/Title';
import { useArticleContext } from '@/routes/Requests/contexts/ArticleContext';
import ProofOfPurchase from '@/routes/Requests/Request/Article/ProofOfPurchase';

import { OrderNumber } from './OrderNumber';
import { PurchaseChannel } from './PurchaseChannel';
import { PurchaseCountry } from './PurchaseCountry';
import { PurchaseDate } from './PurchaseDate';
import { PurchaseLocation } from './PurchaseLocation';
import { WarrantyAlert } from './WarrantyAlert';
import { WarrantyDistributorExtensionToggle } from './WarrantyDistributorExtensionToggle';
import { WarrantyOverrideToggle } from './WarrantyOverrideToggle';

export const WarrantyForm = () => {
  const { article, view, errors } = useArticleContext();

  if (!(view.warranty.shown && view.warranty.type === 'warranty' && view.warranty.editable)) {
    return null;
  }

  const shouldDisplayWarrantyOverrideToggle =
    !article.activeWarrantyType || article.activeWarrantyType === 'override';

  return (
    <FoldableSection
      label={
        <Title as="h2">
          <Trans id="requests.new.articles.drawer.warranty.title">Warranty</Trans>
        </Title>
      }
      isInvalid={errors.warranty?.hasError}
    >
      <Box padding="1rem" gap="1rem" className="bg-neutral-0">
        <Stack gap="1rem">
          {(view.warranty.fields.purchaseDate.shown || article.activeWarrantyType) && (
            <WarrantyAlert article={article} />
          )}

          {view.warranty.fields.purchaseDate.shown && <PurchaseDate />}
          {view.warranty.fields.purchaseLocation.shown && <PurchaseLocation />}
          {view.warranty.fields.purchaseCountry.shown && <PurchaseCountry />}
          {view.warranty.fields.purchaseChannel.shown && <PurchaseChannel />}
          {view.warranty.fields.orderNumber.shown && <OrderNumber />}
          {view.warranty.fields.proofOfPurchase.shown && <ProofOfPurchase />}
          <WarrantyDistributorExtensionToggle />
          {shouldDisplayWarrantyOverrideToggle && <WarrantyOverrideToggle />}
        </Stack>
      </Box>
    </FoldableSection>
  );
};
